import Auth from 'Auth';
import get from 'Utils/lodash.get';
import { getAuthError } from 'Helpers/validations/auth-error-messages';
import { isString } from 'Helpers/utils/common';
import { SERVER_GENERAL_ERROR_MESSAGE, SERVER_GENERAL_ERROR_MESSAGE2 } from 'Config/constans';
import BaseFormModel from './BaseFormModel';

export default class BaseAuthModel extends BaseFormModel {
  constructor(data) {
    super(data);

    this.$resetOnSuccess = false;
    this.$messageSuccess = false;
    this.$authMethod = 'login';
  }

  get _sendArgs() {
    return [];
  }

  static getErrorMessageByServerError(errorData) {
    // Do not show error when user close tab with popup
    if (errorData.original === 'User closed the popup window') return '';
    const apiError = get(errorData, 'response.data');
    const originalError = get(errorData, 'original.response.body');
    const error = apiError || originalError || errorData;
    if (error === undefined) return SERVER_GENERAL_ERROR_MESSAGE;
    // ignore code `access_denied` as error because it's general error code on reject after login
    // but still it's code for wrong password, so check if is the case by description text
    if (error.code && (error.code !== 'access_denied' || error.description === 'Wrong email or password.')) {
      const formattedError = getAuthError(error.code);
      if (formattedError) return formattedError;
    }
    if (error.friendly_message) return error.friendly_message;
    if (error.message) return error.message;
    if (error.description && isString(error.description)) return error.description;
    if (error.error && isString(error.error)) return error.error;
    return SERVER_GENERAL_ERROR_MESSAGE2;
  }

  _getGeneralError(error) {
    return this.constructor.getErrorMessageByServerError(error);
  }

  _onSendError(error) {
    this.__error__ = this._getGeneralError(error);
    this.$v.$touch();
    return error;
  }

  async send() {
    await this._beforeSend();
    return Auth[this.$authMethod](...this._sendArgs) // eslint-disable-line
      .then(this._onSendSuccess.bind(this))
      .then((response) => {
        this._onSendAlways();
        return response;
      })
      .catch((error) => {
        this._onSendError(error);
        this._onSendAlways();
        throw error;
      });
  }
}
